const MESSAGES = {
  FIRST_START: "Начни игру!", // При первом запуске страницы

  START_ROUND: "Разгадай зашифрованное послание.", // Когда начинается раунд

  EMPTY_ANSWER: "Введите ответ для проверки.", // Пустой ответ

  WRONG_ANSWER: "Неверный ответ! Попробуй ещё раз.", // Неверный ответ

  NEXT_ROUND: "Молодец! Нажми «Далее».", // Когда раунд закончился, но есть следующий

  GAME_FINISHED: "Молодец! Все послания разгаданы. Нажми «Играть ещё».", // Когда вся игра закончилась
} as const;

export default MESSAGES;
